var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-navigation',{staticClass:"info white--text",attrs:{"fixed":"","padless":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" Powered by "),_c('a',{attrs:{"href":"https://goldbear.me","id":"powered-by","target":"_blank"}},[_c('strong',[_vm._v("GoldBear Technologies d.o.o.")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }